import App from './App.svelte';

if ("serviceWorker" in navigator) {
	// register service worker
	navigator.serviceWorker.register("sw.js");
	console.debug('ServiceWorker registered');
}  

const app = new App({
	target: document.body
});

export default app;